<template>
  <el-dialog
    :title="$t('shopTypeManage.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="resetForm"
  >
    <div style="text-align:center">
      <p>{{ $t('shopTypeManage.confirmDeleteShopType') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('shopTypeManage.cancel') }}
      </el-button>
      <el-button
        type="primary"
        @click="confirmDelete"
      >
        {{ $t('shopTypeManage.confirmDelete') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteShopType } from '@/api/admin/shopTypeApi'

export default {
  name: 'DeleteShopType',
  data() {
    return {
      dialogVisible: false,
      shopTypeId: ''
    }
  },
  methods: {
    open(row) {
      this.shopTypeId = row.shopTypeId
      this.dialogVisible = true
    },
    resetForm() {
      this.shopTypeId = ''
    },
    async confirmDelete() {
      try {
       const {code,msg} = await deleteShopType({ shopTypeId: this.shopTypeId })
       if(code != 0){
        this.$message.error(msg)
        return
       }
        this.$message.success(this.$t('shopTypeManage.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>